export default function setCookie(name, value, days = 360, path = "/") {
  let expires = new Date(new Date().getTime() + days * 24 * 60 * 60 * 1000).toGMTString();
  document.cookie = `${name}=${value}; expires=${expires}; path=${path};`;
}
